@if(!processing()) {
  <tr class="mt-3">
    <td colspan="3" class="table-no-bottom-border">
      <h5 class="card-title">
        <app-lineicon [line]="line().getNumber()" [abbreviate]="false"></app-lineicon>
      </h5>
    </td>
    @for(gameRound of gameRounds(); track $index ) {
      <td class="table-no-bottom-border text-end">
        @if( line().getNumber() === GoalKeeper ) {
          <button type="button" class="btn btn-sm btn-large-points">
            {{calculateTotalGameRoundPoints(line().getFormation(), gameRound)}}
          </button>
        }      
      </td>
    }
    <td class="table-no-bottom-border text-end">
      @if(totalPoints()) {
        <button type="button" class="btn btn-sm btn-large-totals">
          {{totalPoints()}}
        </button>
      }
    </td>
  </tr>

  @let firstGameRound = gameRounds()[0];  
  @for(place of line().getStartingPlaces(); track place.getId()){  
    @let s11Player = place.getPlayer();
    <ng-container *ngTemplateOutlet="placeRow; context: {place, s11Player, currentTeam: getCurrentTeam(s11Player, $safeNavigationMigration(firstGameRound?.period))}">
    </ng-container>
  }
  <ng-container *ngTemplateOutlet="placeRow; context: {place:line().getSubstitute(), s11Player: line().getSubstitute().getPlayer(), currentTeam: getCurrentTeam(line().getSubstitute().getPlayer(), $safeNavigationMigration(firstGameRound?.period))}">
  </ng-container>  
}

<ng-template #placeRow let-place="place" let-s11Player="s11Player" let-currentTeam="currentTeam">
  
  <tr [class]="{'pointer': s11Player}">   
    <td [attr.colspan]="place.isSubstitute() ? 1 : 2" class="{{getSubstituteClass(place.isSubstitute())}}">
      @if(s11Player) {
        <span>{{s11Player.getPerson().getName()}}</span>
      }
      <!-- <button *ngIf="!s11Player" type="button" class="btn btn-outline-danger btn-sm" (click)="editPlace.emit(place)">
        kies een {{place.isSubstitute() ? 'wissel' : 'speler'}}
      </button> -->
    </td>
    @if(place.isSubstitute()) {
      <td class="{{getSubstituteClass(place.isSubstitute())}}">      
        <span class="badge badge-substitute-unknown">r</span>
      </td>
    }
    <td class="text-nowrap" [class]="getSubstituteClass(place.isSubstitute())">
      @if(currentTeam) {
        <app-team-name [team]="currentTeam" [fullName]="false"></app-team-name>
      }
    </td>
    
    @for(gameRound of gameRounds(); track $index ) {
      <td class="pointer text-end {{getSubstituteClass(place.isSubstitute())}}">
        @let s11Player = place.getPlayer();
        @if( statisticsGetter().getStatistics(s11Player, gameRound.number)) {
          @if(!place.isSubstitute() || statisticsGetter().isSubstituteUsed(place,gameRound)){        
            @if(statisticsGetter().hasAppeared(place, gameRound)){          
              <ng-container
                *ngTemplateOutlet="appearedbtn; context:{formationPlace: place, gameRound, s11Player}">
              </ng-container>            
            }
            @else {
              @let missingPlayerGame = getMissingPlayerGame(s11Player, gameRound);
              <button type="button"
                class="btn btn-sm btn-not-appeared {{getMissingPlayerBorderClass(missingPlayerGame)}}"
                [attr.title]="missingPlayerGame?.missingPlayer?.description ?? 'niet gespeeld'"
                (click)="linkToMissingPlayer.emit({ s11Player, gameRound })">
                @if(missingPlayerGame) {
                  <fa-icon class="text-success" [icon]="getMissingPlayerIcon(missingPlayerGame.missingPlayer)"></fa-icon>
                } @else {
                  NP
                }
              </button>
            }
          }
        }
      </td>
    }
    
    <td class="text-end {{getSubstituteClass(place.isSubstitute())}}">
      <button type="button" class="btn btn-sm btn-large-points">
        {{place.getTotalPoints()}}
      </button>
    </td>
  </tr>
</ng-template>

<ng-template #appearedbtn let-formationPlace="formationPlace" let-s11Player="s11Player" let-gameRound="gameRound">
  @let statistics = statisticsGetter().getStatistics(s11Player, gameRound.number);
  @if( statistics !== undefined ) {
    <div class="text-end me-1">                        
      <button type="button" class="btn btn-sm btn-points-normal mb-1" [class.border-success]="statistics.isManOfTheMatch()" (click)="linkToPlayer.emit({ s11Player, gameRound })">
        {{statisticsGetter().getFormationPlaceGameRoundPoints(formationPlace,gameRound, undefined)}}
      </button>
      <div  class="d-flex flex-column align-items-end">        
        <ngb-progressbar-stacked class="mb-1" style="height: 5px; width: 100%;">
          @for(appColumn of getAppearanceColumns(statistics); track $index){
            <ngb-progressbar type="{{appColumn.playing ? 'primary' : 'secondary'}}" [value]="appColumn.percentage" height="0.5rem"></ngb-progressbar>
          }
        </ngb-progressbar-stacked>                
      </div>                                        
    </div>
  }
</ng-template>